export default "__VITE_ASSET__1bbd8916__"